import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  progress = 25; // Keep this constant for the "filled" amount
  private intervalId: any;

  ngOnInit(): void {
    // Simulate spinning effect
    this.intervalId = setInterval(() => {
      this.progress = (this.progress + 1) % 100; // Animate the spinner
    }, 30); // Adjust speed (lower value = faster spin)
  }

  ngOnDestroy(): void {
    // Clean up the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
